import styled, { keyframes } from "styled-components";

const shimmerSweep = keyframes`
  0% { transform: translateX(-150%); }
  100% { transform: translateX(250%); }
`;

const trophyGlow = keyframes`
  0%, 100% {
    filter: drop-shadow(0 0 8px rgba(247, 234, 188, 0.18));
  }
  50% {
    filter: drop-shadow(0 0 16px rgba(247, 234, 188, 0.35));
  }
`;

export const ModalContainer = styled.div`
  width: 100%;
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.5);
  overflow: hidden;
  max-height: 90dvh;
  overflow-y: auto;
  max-width: 360px;
  border-radius: 24px;
  border: 1px solid #142743;
  background: #0b1727;
  position: relative;
  z-index: 1000;
`;
export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
  height: 100%;
  z-index: 1002;
  width: 100%;
`;

export const TrophyWrapper = styled.div`
  position: relative;
  width: 232px;
  height: 232px;
  align-self: center;
  flex-shrink: 0;
`;

export const TrophyImg = styled.img`
  width: 100%;
  height: 100%;
  display: block;
  animation: ${trophyGlow} 3s ease-in-out infinite;
`;

export const MedalWrapper = styled.div`
  position: relative;
  width: 37px;
  height: 37px;
  flex-shrink: 0;
`;

export const MedalImg = styled.img`
  width: 100%;
  height: 100%;
  display: block;
`;

export const Shimmer = styled.div`
  position: absolute;
  inset: 0;
  pointer-events: none;
  overflow: hidden;
  -webkit-mask-image: url(${(p) => p.$src});
  mask-image: url(${(p) => p.$src});
  -webkit-mask-size: contain;
  mask-size: contain;
  -webkit-mask-repeat: no-repeat;
  mask-repeat: no-repeat;
  -webkit-mask-position: center;
  mask-position: center;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      110deg,
      transparent 30%,
      rgba(255, 255, 255, 0.6) 50%,
      transparent 70%
    );
    animation: ${shimmerSweep} 2.5s linear infinite;
    will-change: transform;
  }
`;

export const ModalTitle = styled.h1`
  color: #fff;
  font-family: Figtree;
  font-size: 20px;
  font-weight: 600;
  text-align: center;
  letter-spacing: -0.09px;
`;

export const ModalText = styled.span`
  color: #fff;
  font-family: Figtree;
  font-size: 14px;
  font-weight: ${(p) => (p.$bold ? "700" : "400")};
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
`;

export const CloseButton = styled.button`
  border: none;
  outline: none;
  background: none;
  cursor: pointer;
  align-self: flex-start;
`;

export const Gradient = styled.div`
  background: radial-gradient(
    27.45% 131.8% at 98.47% 0.77%,
    #f7eabc 0%,
    rgba(12, 12, 14, 0) 100%
  );
  filter: blur(36.25px);
  position: absolute;
  left: -15%;
  z-index: 1001;
  width: 100%;
  height: 100%;
  max-height: 517px;
  rotate: 20deg;
  top: -40%;
  pointer-events: none;
`;
